import { FunctionComponent, PropsWithChildren, useEffect } from 'react'
import { CookieConsent } from 'components/CookieConsent/CookieConsent'
import { useUtm } from 'hooks/utm'

export const BaseLayout: FunctionComponent<PropsWithChildren<{}>> = ({ children }) => {
  const { writeLocalStorage } = useUtm()

  useEffect(() => {
    writeLocalStorage()
  })

  return (
    <div>
      {children}
      <CookieConsent />
    </div>
  )
}
